import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { func, string, object, bool } from "prop-types";
import get from "lodash/get";
import { getExistingUser } from "../../../../api/utils";
import { SocialLogin } from "../SocialLogin";
import { isValidEmail } from "../../utils";

import "./forms.m.css";

const LoginBase = ({
  navigateTo,
  qtConfig,
  userInfo,
  setUserInfo,
  setLoading,
  customCallbackUrl,
  magazine = false,
}) => {
  const [errorMsg, setError] = useState("");
  const trackErrorEmail = (errorMessage) => {
    // Track error for missing email
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_login_error",
        event_action: "email_submit",
        error_message: errorMessage,
      });
    }
  };
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userInfo.email) {
      const errorMessage = "Please provide an email";
      setError(errorMessage);
      // trackErrorEmail(errorMessage);
      return;
    }

    if (!isValidEmail(userInfo.email)) {
      const errorMessage = "Please enter a valid email address";
      setError(errorMessage);
      trackErrorEmail(errorMessage);
      return;
    }

    setLoading(true);
    try {
      const { exists, error } = await getExistingUser(userInfo.email);
      // Track email submit success
      if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
          event: "dl_login_steps",
          event_action: "email_submit",
        });
      }
      if (exists === true) {
        navigateTo("login");
      } else if (exists === false) {
        navigateTo("register");
      } else {
        const errorMessage = "Something went wrong";
        setError(errorMessage);
        console.error("Error checking user existence", error);
        trackErrorEmail(errorMessage);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error checking user existence", err);
      const errorMessage = "An error occurred. Please try again.";
      setError(errorMessage);
      trackErrorEmail(errorMessage);
      setLoading(false);
    }
  };

  const setData = (e) => {
    const userObj = { ...userInfo };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUserInfo(userObj);
  };

  return (
    <div styleName={`auth-container registerContainer ${magazine ? "no-margin-bottom" : ""}`}>
      <h2 styleName="auth-title">{magazine ? "Sign in to read full story" : "Sign In or Register"}</h2>
      <p styleName="description">
        {magazine
          ? "To access our exclusive magazine content, sign in to your Open Magazine account."
          : "Access exclusive insights, stories, and opportunities with Open Magazine. Sign in to continue your journey or create an account to join our thriving community."}
      </p>

      <div styleName="socialLogin">
        <p styleName="continueText">{magazine ? "Sign in via" : "CONTINUE WITH"}</p>
        <SocialLogin customCallbackUrl={customCallbackUrl} magazine={magazine} />
      </div>

      <p styleName="continueText">OR</p>

      <form styleName="form">
        <label htmlFor="email" styleName="auth-label">
          Enter Email
        </label>
        <input
          type="email"
          id="email"
          value={userInfo.email}
          onChange={setData}
          placeholder="Enter your email"
          onFocus={() => setError("")}
          required
          styleName="auth-input"
        />

        {errorMsg && <p styleName="error">{errorMsg}</p>}

        <button type="submit" styleName="submit-button" onClick={handleEmailSubmit}>
          Continue
        </button>
      </form>

      {!magazine && (
        <p styleName="termsText">
          By continuing, you agree to Open Magazine's
          <a href="/policies" target="_blank" styleName="link">
            {" "}
            Terms & Conditions
          </a>{" "}
          and
          <a href="/privacy-policy" target="_blank" styleName="link">
            {" "}
            Privacy Policy
          </a>
          .
        </p>
      )}
    </div>
  );
};

LoginBase.propTypes = {
  setMember: func,
  navigateTo: func,
  qtConfig: object,
  currentPath: string,
  customCallbackUrl: string,
  userInfo: object,
  setUserInfo: func,
  setLoading: func,
  magazine: bool,
};

const mapStateToProps = (state) => ({
  qtConfig: get(state, ["qt", "config"], {}),
  currentPath: get(state, ["qt", "currentPath"], ""),
});

export const SignUpLanding = connect(mapStateToProps, null)(LoginBase);
